export type GeocodeParts = {
  street: string
  city: string | null
  country: string | null
  postalCode: string | null
  coordinates: { lat: number; lng: number } | null
}

/**
 * Geocode a Places prediction into structured components. The prediction
 * description alone is unreliable for saving — it usually omits the postal code,
 * so parsing it by hand mis-assigns the city. Callers fall back to the raw
 * description when geocoding fails.
 */
export function parseGeocodeResult(result: google.maps.GeocoderResult, prediction: google.maps.places.AutocompletePrediction): GeocodeParts {
  let streetNumber = ''
  let route = ''
  let city = ''
  let postalCode = ''
  let country = ''

  for (const component of result.address_components) {
    if (component.types.includes('street_number')) streetNumber = component.long_name
    if (component.types.includes('route')) route = component.long_name
    if (component.types.includes('locality') || component.types.includes('postal_town')) city = component.long_name
    if (component.types.includes('postal_code')) postalCode = component.long_name
    if (component.types.includes('country')) country = component.long_name
  }

  const street = [streetNumber, route].filter(Boolean).join(' ') || prediction.structured_formatting.main_text
  const location = result.geometry?.location

  return {
    street,
    city: city || null,
    country: country || null,
    postalCode: postalCode || null,
    coordinates: location ? { lat: location.lat(), lng: location.lng() } : null,
  }
}
